import { helpers } from './base'

export const TravelerRoom = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle({
    roomNumberTitle: {
      fontSize: 'sm',
    },
    travellerLabel: {
      fontSize: 'lg',
      fontWeight: 'light',
    },
    agedLabel: {
      fontSize: 'xs',
    },
  }),
})
